import React, { ReactElement } from 'react';
import { twMerge } from 'tailwind-merge';
import Button from '../Button';
import Loader from '../Loader';
import Typography from '../Typography';
import Tooltip from '../Tooltip';

type type = 'information' | 'loading' | 'confirmation';

interface Props {
  panelType: type;
  subtitle?: string;
  buttonId?: string;
  buttonText?: string;
  linkText?: string;
  onClick?: any;
  link?: string;
  imageMobile?: string;
  image?: string;
  tooltipText?: ReactElement;
  tooltipLink?: string;
  tooltipTextLink?: string;
  title: string;
  description: ReactElement | string;
  className?: string;
  children?: React.ReactNode;
  gtm?: any;
}

const Panel = ({
  panelType = 'confirmation',
  subtitle,
  buttonId,
  buttonText,
  linkText,
  onClick,
  link,
  imageMobile,
  image,
  tooltipText = <></>,
  tooltipLink,
  tooltipTextLink,
  title,
  description,
  className,
  children,
  gtm,
}: Props) => {
  return (
    <div
      id="mp__panel"
      className={twMerge(
        'flex items-center justify-center mt-12 mb-12 max-md:mx-[15px] max-md:mt-[23px]',
        className
      )}
    >
      <div className="relative w-full max-w-[712px] bg-neutral-light/20 rounded-lg min-h-[372px] max-md:bg-transparent">
        {imageMobile && (
          <div className="block md:hidden mx-6">
            <img src={imageMobile} alt="" />
          </div>
        )}
        <div className="pt-16 pb-24 pl-60 pr-44 max-md:pt-12 max-md:px-0 max-md:pb-6">
          {panelType === 'loading' && (
            <div className="mb-6 max-md:flex max-md:justify-center">
              <Loader show={true} />
            </div>
          )}
          <Typography
            as="div"
            variant="title1"
            className="text-neutral-darkest mb-6 max-md:w-[98%]"
          >
            {title}
            {panelType === 'information' && (
              <Tooltip
                text={tooltipText}
                link={
                  <a href={tooltipLink} target="_blank" rel="noreferrer">
                    {tooltipTextLink}
                  </a>
                }
                onClick={gtm}
              />
            )}
          </Typography>
          {subtitle && (
            <Typography as="p" variant="body2" className="text-neutral-darkest mb-6">
              {subtitle}
            </Typography>
          )}
          {children || (
            <Typography as="p" variant="body2" className="text-neutral-darkest mb-6 max-md:w-full">
              {description}
            </Typography>
          )}
          {buttonText && (
            <Button
              id={buttonId}
              type="button"
              text={buttonText}
              classNames="w-full md:max-w-[226px] mt-6"
              onClick={onClick}
              variant="primary"
            />
          )}
          {linkText && (
            <div className="mt-6">
              <a
                id="panel-link"
                className="text-support2-medium text-sm font-bold leading-4"
                href={link}
                onClick={onClick}
              >
                {linkText}
              </a>
            </div>
          )}
        </div>
        {image && (
          <div className="absolute top-0 -left-[18%] max-md:hidden">
            <img src={image} alt="" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Panel;
